import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=3b6a0c0f&scoped=true"
import script from "./TextComponent.vue?vue&type=script&lang=js"
export * from "./TextComponent.vue?vue&type=script&lang=js"
import style0 from "./TextComponent.vue?vue&type=style&index=0&id=3b6a0c0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a0c0f",
  null
  
)

export default component.exports